import React, { Component } from 'react';
import { StyleSheet, Text, View, Dimensions, SectionList } from 'react-native';

import SizeUtil from '../../../utils/SizeUtil';
import CityItem from './cityItem';
import IndexScrollBar from './IndexScrollBar';
import { listSource, ListSourceItemModel } from '../staticDataSource/index';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

const { height } = Dimensions.get('window');

const ROW_HEIGHT = 45;
const separatorHeight = 1;
const HEADREHEIGHT = 24;
const scrollBarItemHeight = SizeUtil.getSize(16);

let dataCount = 22;

interface Props {
    absoluteStartY: number;
    isInland: boolean;
}

interface State {
    hotCityDataListHeight: number;
    dataSource: any;
}

// 城市列表SectionList页
export default class IndexList extends Component<Props, State> {
    public listRef: SectionList<any>;
    public state: any;
    public constructor(props: Props) {
        super(props);
        const dataSource = Object.keys(listSource).map((key, index) => {
            return { title: key, data: Array.from(listSource[key]) };
        });
        this.state = {
            dataSource
        };
    }

    public _scrollToLocation = (moduleIndex: number) => {
        const dataListsKey = Object.keys(listSource);
        if (moduleIndex >= dataListsKey.length) {
            return;
        }
        let numPreItems = 0;
        let i = 0;
        for (; i < moduleIndex; i++) {
            numPreItems += listSource[dataListsKey[i]].length;
        }
        const sumOffset =
            numPreItems * (ROW_HEIGHT + separatorHeight) +
            moduleIndex * HEADREHEIGHT -
            moduleIndex * separatorHeight;
        const scrollResponder = this.listRef.getScrollResponder();
        if (i >= 21) {
            scrollResponder.scrollToEnd({ animated: false });
        } else {
            scrollResponder.scrollTo({ y: sumOffset, animated: false });
        }
    };

    // 计算header的高度（包含：定位+历史+热门模块）
    // _getHeaderViewHeight = () => {
    //     const { isInland } = this.props;
    //     const { hotCityDataListHeight } = this.state;
    //     let headerHeight = 0;
    //     headerHeight += SizeUtil.getSize(57 + 16);
    //     let historyPartHei = 0;
    //     if (isInland && global.isExistHistoryInlandCity) {
    //         historyPartHei = SizeUtil.getSize(82);
    //     } else if (!isInland && global.isExistHistoryAbroadCity) {
    //         historyPartHei = SizeUtil.getSize(82);
    //     }
    //     let hotCityPartHei = 0;
    //     if (hotCityDataListHeight > 0) {
    //         hotCityPartHei = SizeUtil.getSize(38)
    //             + SizeUtil.getSize(44) * (Math.ceil(hotCityDataListHeight / 3));
    //     }
    //     return headerHeight + historyPartHei + hotCityPartHei;
    // }

    // _getDataSourceLength(dataLists) {
    //     dataLists.forEach((section) => {
    //         dataCount += section.data.length + 1;
    //     });
    //     return dataCount;
    // }

    // row
    public renderItem = (data: any) => <CityItem info={data} />;

    // 分割线
    public separatorComponent() {
        return <View style={styles.separtorStyle} />;
    }

    // 每个分组Section的Header
    public renderSectionHeader(sectionData: any) {
        return (
            <View
                style={{
                    backgroundColor: '#f7f7f7',
                    height: HEADREHEIGHT,
                    justifyContent: 'center'
                }}
            >
                <Text style={styles.sectionStyle}>{sectionData.section.title}</Text>
            </View>
        );
    }

    public render() {
        const { dataSource } = this.state;
        const { absoluteStartY, isInland } = this.props;
        return (
            <View style={{ flex: 1 }}>
                <SectionList
                    initialNumToRender={300}
                    ref={(ref) => {
                        this.listRef = ref;
                    }}
                    sections={dataSource}
                    showsVerticalScrollIndicator={false}
                    stickySectionHeadersEnabled
                    ItemSeparatorComponent={this.separatorComponent}
                    renderSectionHeader={
                        // (sectionData:any, sectionID:any) => this.renderSectionHeader(sectionData, sectionID)
                        this.renderSectionHeader
                    }
                    renderItem={({ item, index }) => this.renderItem({ item, index })}
                    keyExtractor={(item, index) => String(index)}
                />

                <IndexScrollBar
                    dataLists={listSource}
                    absoluteStartY={absoluteStartY}
                    isInland={isInland}
                    scrollToLocation={(moduleIndex: number) => {
                        this._scrollToLocation(moduleIndex);
                    }}
                />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    sectionStyle: {
        color: baseColor.text3,
        lineHeight: HEADREHEIGHT,
        paddingLeft: SizeUtil.getSize(19.5)
    },
    rowStyle: {
        marginLeft: SizeUtil.getSize(20),
        marginRight: SizeUtil.getSize(20),
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    rowTextStyle: {
        fontSize: 15,
        color: baseColor.text1
    },
    separtorStyle: {
        height: separatorHeight,
        backgroundColor: baseColor.background2,
        marginHorizontal: SizeUtil.getSize(20)
    },
    noDataViewStyle: {
        backgroundColor: 'red',
        flex: 1,
        height
    },
    noDataSubViewStyle: {
        alignItems: 'center',
        textAlign: 'center',
        lineHeight: height,
        color: 'white'
    },
    sectionItemViewStyle: {
        position: 'absolute',
        width: scrollBarItemHeight,
        top: 0
    },
    sectionItemStyle: {
        fontSize: 12,
        textAlign: 'center',
        alignItems: 'center'
    }
});
